"use client";
var _a;
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useCallback, useContext, useMemo, useState } from "react";
import createTheme from "./create-theme.js";
import { createPalette } from "./palette/create-palette.js";
function getLocalStorage() {
    if (typeof window === "undefined")
        return;
    return window.localStorage;
}
const initialScheme = (_a = getLocalStorage()) === null || _a === void 0 ? void 0 : _a.getItem("color-scheme");
const defaultTheme = createTheme();
const ThemeContext = React.createContext({
    scheme: initialScheme,
    setScheme: (_value) => {
        throw new Error("Cannot set the color scheme without ThemeProvider");
    },
    theme: defaultTheme,
});
export function ThemeProvider({ theme = defaultTheme, defaultScheme = initialScheme || "light", children, }) {
    const [_scheme, _setScheme] = useState(theme.schemes[defaultScheme] ? defaultScheme : "light");
    const scheme = theme.schemes[_scheme] ? _scheme : theme.schemes[defaultScheme] ? defaultScheme : "light";
    const setScheme = useCallback((value) => {
        _setScheme(scheme => {
            var _a;
            const newValue = typeof value === "function" ? value(scheme) : value;
            (_a = getLocalStorage()) === null || _a === void 0 ? void 0 : _a.setItem("color-scheme", newValue);
            return newValue;
        });
    }, []);
    const result = useMemo(() => {
        const { colors, scheme: colorScheme } = theme.schemes[scheme];
        const result = Object.assign(Object.assign({}, theme), { scheme: colorScheme, colors });
        result.palette = createPalette(result);
        return result;
    }, [theme, scheme]);
    const Context = ThemeContext;
    return _jsx(Context.Provider, { value: { scheme, setScheme, theme: result }, children: children });
}
export function useTheme() {
    return useContext(ThemeContext);
}
export default ThemeProvider;
//# sourceMappingURL=theme-provider.js.map